import {createSlice, PayloadAction, createSelector} from '@reduxjs/toolkit';
import _pick from 'lodash/pick';
import type {RootState} from '../../types';
import type {GiftCertificate} from './types';

const giftCertificateSelector = (state: RootState) => state.giftCertificate;

export const giftCertificateSlice = createSlice({
	name: 'giftCertificate',
	initialState: {},
	reducers: {
		receiveGiftCertificate: (state: GiftCertificate, action: PayloadAction<GiftCertificate>) => {
			state = Object.assign(state, _pick(action.payload, ['enabled', 'balance', 'c_currencyCode']));
		},
	}
});

export const {receiveGiftCertificate} = giftCertificateSlice.actions;
export const selectGiftCertificate = createSelector(giftCertificateSelector, (giftCertificate) => giftCertificate);
export default giftCertificateSlice.reducer;
